import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ClerkProvider } from "@clerk/react";
import "@dropdex/ui/styles.css";
import "./web.css";
import { WebApp } from "./web-app";

const clerkPublishableKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;
const application = <WebApp />;

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    {clerkPublishableKey ? (
      <ClerkProvider
        publishableKey={clerkPublishableKey}
        signInUrl="/sign-in"
        signUpUrl="/sign-up"
        signInFallbackRedirectUrl="/account/billing"
        signUpFallbackRedirectUrl="/account/billing"
        localization={{
          signUp: {
            start: {
              title: "Sign up for DropDex Alerts",
              titleCombined: "Sign up for DropDex Alerts",
              subtitle: "Start your 7-day free trial.",
              subtitleCombined: "Start your 7-day free trial."
            }
          }
        }}
      >
        {application}
      </ClerkProvider>
    ) : application}
  </StrictMode>
);
